<template>
  <div class="list-pic">
        <el-row :gutter="$global.isMobile ? 10 : 40" >
            <el-col :span="$global.isMobile ? 20 : 8" v-for="(item) in list" :key="item.id" :offset="$global.isMobile?2:0">
                <div class="list-pic__item" @mouseleave="currentItem=null" @mouseenter="currentItem=item.id" @click="artistShow(item)">
                    <el-image class="lpi-avatar" :src="item.cover"  :key="item.cover" v-if="item.cover" >
                        <div slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                    <div class="lpi-info">
                        <p class="lpi-info__name">{{ item.content[$i18n.locale].name  }}</p>
                        <p class="lpi-info__type">
                            <!-- {{ item.types.length?item.types.join('/'):'--' }} -->
                            <span v-for="(tItem,index) in item.types" :key="index">{{ tItem[$i18n.locale]+ (item.types.length===(index+1)?' ':' / ') }}</span>
                        </p>
                    </div>
                    <template v-if="currentItem===item.id">
                    <!-- <template v-if="1"> -->
                        <div class="lpi-bg"></div>
                        <div class="lpi-bg__desc"  v-html="getText(item.content[$i18n.locale].desc)">
                        </div>
                        <img class="lpi-bg__go" src="@/assets/images/pic_icon_go.png">
                    </template>
                    
                </div>
            </el-col>
        </el-row>
  </div>
</template>

<script>
import { vHtml2String } from '@/utils'
export default {
    props:{
        list:{
            type:Array,
            default(){
                return []
            },
        },
    },
    data(){
        return {
            currentItem:null
        }
    },
    methods:{
        getText(HTML){
           return vHtml2String(HTML)
        },
        artistShow(data){
            this.$emit('artist-show',data)
        }
    }
}
</script>

<style lang="less" >
.list-pic{
    width: 1200px;
    margin: 0 auto;
    .list-pic__item{
        position: relative;
        display: flex;
        flex-direction: column;
        height:473px;
        margin-bottom: 40px;
        cursor: pointer;
        .lpi-avatar{
            // width: 100%;

            width: 100%;
            height: 373px;
            margin:0 auto;
            border-radius: 48px;
            flex: none;
            .lpi-avatar__slot{
                background: rgba(31, 42, 102, 0.6);
            backdrop-filter: blur(30px);
                height: 100%;
                width: 100%;
            }
        }
        .lpi-info{
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: center;
            z-index: 2;
            flex: 1;
            box-sizing: border-box;
            padding-left: 28px;
            .lpi-info__name{
                font-size: 18px;
                color: #fff;
                margin-bottom: 8px;
            }
            .lpi-info__type{
                font-size: 14px;
                color: rgba(255, 255, 255, 0.6);
            }
           
            
        }
        .lpi-bg{
            position: absolute;
            z-index: 1;
            bottom: 0;
            width: 100%;
            height: 250px;        
            border-radius: 48px;
            background: rgba(31, 42, 102, 0.6);
            backdrop-filter: blur(30px);
        }
        .lpi-bg__desc{
            position: relative;
            display: block;
            color: #fff;
            font-size: 14px;
            z-index: 2;
            box-sizing: border-box;
            padding:0 24px;
            overflow : hidden;
            width: 100%;
            // height: 75px;
            height: auto;
            
            top: -150px;
            flex: none;
            clip-path:inset(0px);

            text-overflow: ellipsis;
                overflow: hidden;
                text-overflow: -webkit-ellipsis-lastline;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                line-clamp: 3;
                word-break: break-all;
                -webkit-box-orient: vertical;
                line-height: 2;
                max-height: 6em;
                &>*{
                    font-size: 14px !important;
                    line-height: 24px;
                    &>*{
                        font-size: 14px !important;
                        line-height: 24px;
                    }
                }
            
        }
        .lpi-bg__go{
                position: absolute;
                z-index: 3;
                right: 24px;
               bottom: 38px;
            }
    }
}
@media screen and (max-width: 767px) {
    .list-pic{
        width: 100%;
        .list-pic__item{
            overflow: hidden;
            height: 80vw;
            margin-bottom:8vw;
            .lpi-avatar{
                height: 100%;
            }
            .lpi-info{
                width: 100%;
                position: absolute;
                bottom: 0;
                background: #0000009e; 
                box-sizing: border-box;
                padding-left: 2.6667vw;
                .lpi-info__name{
                    font-size: 4vw;
                    padding: 1.3333vw;
                }
                .lpi-info__type{
                    font-size: 4vw;
                    padding: 1.3333vw;
                }
            }
        }
    }
}
</style>